import { createSelector } from '@ngrx/store';
export const getAppStateSliceKey = ({ appStateSliceKey, }) => appStateSliceKey;
export const getChartState = ({ appStateSliceKey, ...state }) => state[appStateSliceKey];
// Securities Info
export const getSecuritiesInfo = ({ securitiesInfo }) => securitiesInfo;
export const getSecuritylistSecurityId = createSelector(getChartState, ({ securitylistSecurityId }) => securitylistSecurityId);
export const getSecuritylistName = createSelector(getChartState, ({ securitylistName }) => securitylistName);
export const getSecurityGroup = createSelector(getChartState, ({ securityGroup }) => securityGroup);
export const getSelectedSecuritylistItemDisplayId = createSelector(getSecuritiesInfo, getSecuritylistSecurityId, (securitiesInfo, securitylistSecurityId) => {
    if (securitylistSecurityId in securitiesInfo) {
        return securitiesInfo[securitylistSecurityId].display_security_id;
    }
    return 'Loading...';
});
